<template>
	<b-form autocomplete="off">
		<h3>Nome</h3>
		<b-form-row>
			<b-col cols="12">
				<input-component v-model="company" :required="true" label="Razão Social" maxlength="255"
					name="company" />
			</b-col>

			<b-col cols="12">
				<input-component v-model="company_fantasy" :required="true" label="Nome Comercial/Fantasia"
					maxlength="255" name="company_fantasy" />
			</b-col>
		</b-form-row>

		<h3>Endereço registrado</h3>
		<address-form-component ref="mainAddress" />

		<h3>Endereço físico da sede administrativa</h3>
		<b-form-group :label-cols="$root.isMobile() ? '12' : '6'" class="mb-4"
			label="Seu endereço físico é o mesmo endereço do registrado?">
			<b-form-radio-group id="same_address" v-model="same_address" :options="addressOptions"
				name="same_address" />
		</b-form-group>

		<address-form-component v-if="!same_address" ref="secondAddress" class="mt-5" />

		<h3>Grupo econômico</h3>
		<b-form-group :label-cols="$root.isMobile() ? '12' : '6'" class="mb-4"
			label="A empresa faz parte de algum grupo econômico?">
			<b-form-radio-group id="group" v-model="has_group" :options="groupOptions" name="group" />
		</b-form-group>

		<div v-if="has_group">
			<b-form-row class="mt-5">
				<b-col cols="12" md="8">
					<input-component v-model="group_name" :required="has_group" label="Nome do grupo" maxlength="255"
						name="group_name" />
				</b-col>

				<b-col cols="12" md="4">
					<input-component v-model="group_taxId" :check="true" :mask="'##.###.###/####-##'"
						:required="has_group" label="CNPJ" maxlength="50" name="group_taxId" />
				</b-col>

			</b-form-row>
		</div>



		<files-component ref="address" :fileType="'address'" :files="[]" :modal-id="'modal-confirm-document'"
			:uploadedFiles="$store.state.form.uploadedDocuments.address"
			label="Cópia do documento que ateste o endereço registrado"
			sub-label="conta de serviço público ou atestado de entidade competente: conta de água, luz, telefone, etc." />

		<files-component v-if="!same_address" ref="secondAddressFiles"
			:fileType="'second_address'" :files="[]" :required="true" :modal-id="'modal-confirm-document'"
			:uploadedFiles="$store.state.form.uploadedDocuments.secondAddress"
			label="Cópia do documento que ateste o endereço físico"
			sub-label="conta de serviço público ou atestado de entidade competente: conta de água, luz, telefone, etc." />

		<h3>Outros dados</h3>
		<b-form-row>
			<b-col cols="12" md="7">
				<input-component v-model="website" :required="false" label="Site Institucional" maxlength="255"
					name="website" />
			</b-col>

			<b-col cols="12" md="5">
				<input-component v-model="product" :required="true" label="Site da Loja" maxlength="255"
					name="product" />

				<div class="sites-container" v-for="(site, index) in sites">
					<input-component type="url" :required="true" label="Site da Loja" v-model="sites[index]"
						:placeholder="'Site ' + (index + 2)" maxLength="255" name="sites" />

					<button class="remove-btn" @click="handleRemoveClick(index)" type="button">Remover</button>
				</div>

				<button class="add-btn" @click="handleAddClick" type="button">Adicionar site</button>
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12">
				<input-component v-model="age" :check="true" :mask="'##/##/####'" :required="true"
					label="Data de fundação" maxlength="50" name="age" />
			</b-col>

			<b-col cols="12">
				<input-component v-model="type" :required="true" label="Tipo (LTDA, S.A, etc.)" maxlength="50"
					name="type" />
			</b-col>
		</b-form-row>

		<h3>Produto / Serviço</h3>
		<b-form-row>
			<b-col cols="12" md="12">
				<select-component v-model="product_category" :options="categories" :required="true"
					label="Selecione a categoria do produto / serviço" name="product_category" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" md="12">
				<text-area-component v-model="product_description" :required="true"
					label="Descreva aqui o seu produto / serviço." rows="3" max-rows="6" name="product_description" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col class="mmb-4" cols="12" md="8">
				<span auto-resize class="legend" rows="1">
					Tempo médio para a entrega do produto ou serviço ao cliente final?
				</span>
			</b-col>
		</b-form-row>

		<select-component v-model="product_shipping" :options="shippingOptions" :required="true"
			style="position: relative; margin-top: 28px" label="Selecione o número de dias" name="product_shipping" />

		<files-component ref="taxId" :fileType="'taxId'" :files="[]" :required="true"
			:uploadedFiles="$store.state.form.uploadedDocuments.taxId" label="Cópia do cartão CNPJ"
			:modal-id="'modal-confirm-document'" />

		<files-component ref="contract" :fileType="'contract'" :files="[]" :required="true"
			:uploadedFiles="$store.state.form.uploadedDocuments.contract" label="Cópia do contrato social"
			sub-label="deve constar no documento anexado o % de propriedade dos indivíduos ou entidades que detenham mais de 25% de participação"
			:modal-id="'modal-confirm-document'" />

		<files-component ref="socialContract" :fileType="'social_contract'" :files="[]"
			:uploadedFiles="$store.state.form.uploadedDocuments.socialContract" :modal-id="'modal-confirm-document'"
			label="Cópia da última alteração do contrato social, estatuto ou ata" />

		<confirm-modal-component type="document" modal-id="modal-confirm-document" />

		<b-form-checkbox id="checkbox-confirm" v-model="agreeCheckbox" class="mb-3" name="checkbox-confirm">
			Declaro que estou autorizado(a) a preencher este formulário em nome da empresa, e me responsabilizo pela
			veracidade das informações prestadas.
		</b-form-checkbox>


	</b-form>
</template>

<style>
.sites-container {
	display: flex;
	flex-direction: row;
	gap: 0px;
	margin-bottom: 8px;
	transform: translate(0px, -8px);
}

.remove-btn {
	height: 38px;
}

.add-btn {
	align-self: start;
	margin-bottom: 16px;
	transform: translate(0px, -16px);
}
</style>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";

import categories from "@/static/categories";

import InputComponent from "@/components/Form/Inputs/InputComponent";
import SelectComponent from "@/components/Form/Inputs/SelectComponent";
import AddressFormComponent from "@/components/Form/AddressFormComponent";
import TextAreaComponent from "@/components/Form/Inputs/TextAreaComponent";
import FilesComponent from "@/components/Form/Inputs/FilesComponent";
import ConfirmModalComponent from "@/components/Form/ConfirmModalComponent";
export default {
	name: "EstablishmentFormComponent",
	components: {
		InputComponent,
		SelectComponent,
		AddressFormComponent,
		TextAreaComponent,
		FilesComponent,
		ConfirmModalComponent,
	},
	props: { validationTrigger: Boolean },
	async mounted() {
		if (this.$store.state.form.establishment.company) {
			this.$emit("setReadyToSubmit", false);
			this.$store.state.form.establishment.agree = false;

			if (this.$v) {
				this.$v.$touch();
			}

			if (this.$refs.mainAddress && this.$refs.mainAddress.$v) {
				this.$refs.mainAddress.$v.$touch();
			}

			if (this.$refs.secondAddress && this.$refs.secondAddress.$v) {
				this.$refs.secondAddress.$v.$touch();
			}

			if (!sessionStorage.getItem("kyc_uuid")) {
				sessionStorage.setItem("kyc_uuid", this.$route.query.id);
			}
		}

		this.$store.dispatch("updateStep", this.step);
	},
	data() {
		return {
			shippingOptions: [
				{ value: "Imediatamente", label: "Até 1 dia útil" },
				{ value: "Até 7 dias úteis", label: "Até 7 dias úteis" },
				{ value: "Até 15 dias úteis", label: "Até 15 dias úteis" },
				{ value: "Até 30 dias úteis", label: "Até 30 dias úteis" },
				{ value: "Até 60 dias úteis", label: "Até 60 dias úteis" },
				{ value: "Maior ou igual a 60 dias úteis", label: "Maior ou igual a 60 dias úteis" },
			],
			addressOptions: [
				{
					text: "Sim, é o mesmo endereço.",
					value: true,
				},
				{
					text: "Não, é outro.",
					value: false,
				},
			],
			groupOptions: [
				{
					text: this.$t("messages.yes"),
					value: true,
				},
				{
					text: this.$t("messages.no"),
					value: false,
				},
			],
		};
	},
	methods: {
		handleAddClick() {
			this.$store.state.form.establishment.sites.push("");
		},
		handleRemoveClick(index) {
			this.$store.state.form.establishment.sites.splice(index, 1);
		},
		isValidUrl(value) {
			const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
			return urlRegex.test(value);
		},
		getEstablishmentFileCount(formKey) {
			const uploaded = this.$store.state.form.uploadedDocuments?.[formKey] || [];
			const pendingDeletes = this.$store.state.form.pendingDeletes?.[formKey] || [];
			const pending = this.$store.state.form.pendingFiles?.[formKey] || [];
			const effectiveUploaded = uploaded.filter(
				(doc) => !this.isEstablishmentDocPendingDelete(doc, pendingDeletes)
			);
			return effectiveUploaded.length + pending.length;
		},
		isEstablishmentDocPendingDelete(doc, pendingDeletes) {
			if (!pendingDeletes || !pendingDeletes.length) return false;
			const docId = doc.salesforceFileId || doc.id;
			const docName = doc.name || doc.filename;
			return pendingDeletes.some((d) => {
				const deleteId = d.salesforceFileId || d.file?.salesforceFileId || d.file?.id;
				if (docId && deleteId && docId === deleteId) return true;
				const deleteName = d.name || d.file?.name || d.file?.filename;
				if (docName && deleteName && docName === deleteName) return true;
				return false;
			});
		},
	},
	watch: {
		isValid(value) {
			this.$emit("setReadyToSubmit", value);
		},
		validationTrigger() {
			this.$emit("setReadyToSubmit", this.isValid);
		},
	},
	computed: {
		isValid() {
			if (!this.$v) {
				return false;
			}

			const mainAddressValid = this.$refs.mainAddress && this.$refs.mainAddress.$v ? !this.$refs.mainAddress.$v.$invalid : false;
			
			let secondAddressValid = true;
			if (!this.same_address) {
				secondAddressValid = this.$refs.secondAddress && this.$refs.secondAddress.$v ? !this.$refs.secondAddress.$v.$invalid : false;
			}

			return (
				this.agreeCheckbox &&
				!this.$v.$invalid &&
				mainAddressValid &&
				secondAddressValid
			);
		},
		agreeCheckbox: {
			get() {
				return this.$store.state.form.establishment.agree;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "agree",
					value,
				});
			},
		},
		company: {
			get() {
				return this.$store.state.form.establishment.company;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "company",
					value,
				});
			},
		},
		company_fantasy: {
			get() {
				return this.$store.state.form.establishment.company_fantasy;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "company_fantasy",
					value,
				});
			},
		},
		website: {
			get() {
				return this.$store.state.form.establishment.website;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "website",
					value,
				});
			},
		},
		product: {
			get() {
				return this.$store.state.form.establishment.product;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "product",
					value,
				});
			},
		},
		sites: {
			get() {
				return this.$store.state.form.establishment.sites;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "sites",
					value,
				});
			},
		},
		age: {
			get() {
				return this.$store.state.form.establishment.age;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "age",
					value,
				});
			},
		},
		type: {
			get() {
				return this.$store.state.form.establishment.type;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "type",
					value,
				});
			},
		},
		same_address: {
			get() {
				return this.$store.state.form.establishment.sameAddress;
			},
			set(value) {
				this.agreeCheckbox = false;
				this.$store.commit("setEstablishment", {
					key: "sameAddress",
					value,
				});
			},
		},
		has_group: {
			get() {
				return this.$store.state.form.establishment.hasGroup;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "hasGroup",
					value,
				});
			},
		},
		product_category: {
			get() {
				return this.$store.state.form.establishment.product_category;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "product_category",
					value,
				});
			},
		},
		product_description: {
			get() {
				return this.$store.state.form.establishment.product_description;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "product_description",
					value,
				});
			},
		},
		product_shipping: {
			get() {
				// Atualização conforme task KYCNB-430, onde o valor "Imediatamente" foi alterado para "Até 1 dia útil".
				if (this.$store.state.form.establishment.product_shipping === "Imediatamente") {
					return "Até 1 dia útil";
				}

				return this.$store.state.form.establishment.product_shipping;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "product_shipping",
					value,
				});
			},
		},
		group_name: {
			get() {
				return this.$store.state.form.establishment.group.name;
			},
			set(value) {
				this.$store.commit("setEstablishmentGroup", {
					key: "name",
					value,
				});
			},
		},
		group_taxId: {
			get() {
				return this.$store.state.form.establishment.group.taxId;
			},
			set(value) {
				this.$store.commit("setEstablishmentGroup", {
					key: "taxId",
					value,
				});
			},
		},
		categories() {
			return categories;
		},
		step() {
			return this.$store.state.form.step;
		},
		taxIdFileCount() {
			return this.getEstablishmentFileCount("taxId");
		},
		secondAddressFileCount() {
			return this.getEstablishmentFileCount("secondAddress");
		},
		contractFileCount() {
			return this.getEstablishmentFileCount("contract");
		},
		taxIdFiles() {
			return this.taxIdFileCount;
		},
		secondAddressFiles() {
			return this.secondAddressFileCount;
		},
		contractFiles() {
			return this.contractFileCount;
		},
	},
	validations: {
		company: {
			required,
		},
		company_fantasy: {
			required,
		},
		website: {}, // Valor precisa existir devido ao loop no validador
		product: {
			required,
		},
		sites: {
			$each: {
				required,
			},
		},
		age: {
			required,
			isValidDate(date) {
				return this.$root.isValidDate(date);
			},
		},
		type: {
			required,
		},
		group_name: {
			requiredIf: requiredIf(function () {
				return this.has_group;
			}),
		},
		group_taxId: {
			requiredIf: requiredIf(function () {
				return this.has_group;
			}),
			isValidCNPJ(taxId) {
				return this.$root.isValidCNPJ(taxId) || !this.has_group;
			},
		},
		product_category: {
			required,
		},
		product_description: {
			required,
		},
		product_shipping: {
			required,
		},
		taxIdFiles: {
			atLeastOne(value) {
				return value >= 1;
			},
		},
		contractFiles: {
			atLeastOne(value) {
				return value >= 1;
			},
		},
		secondAddressFiles: {
			atLeastOne(value) {
				return this.same_address || value >= 1;
			},
		},
	},
};
</script>
